"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.main = "rgb(38,41,54)";
exports.main_l = "rgb(55, 57, 70)";
exports.main_d = "rgb(30, 32, 43)";
exports.mutedMain = "#303443";
exports.gray = "#a8b3dc";
exports.gray_l = "#B5BBD6";
exports.gray_d = "#5d647f";
exports.shadow = "0px 2px 6px rgba(0, 0, 0, 0.1)";
exports.red = "#f63b34";
exports.blue = "#02adc3";
exports.blue_d = "#018a9c";
exports.green = "#78a303";
exports.yellow = "#EEB902";
exports.orange = "#F45D01";
//# sourceMappingURL=colours.js.map